import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { BehaviorSubject } from 'rxjs';
import { PerfilEnum } from '../shared/enum/perfil.enum';
import { PerfilCorporativoVO } from '../shared/model/perfil-corporativo-vo.model';
import { PerfilCorporativoService } from './perfil-corporativo.service';
import { SecurityService } from './security.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilControleService {

  private perfis: BehaviorSubject<PerfilCorporativoVO[]> = new BehaviorSubject<PerfilCorporativoVO[]>(null);

  constructor(
    private readonly perfilCorporativoService: PerfilCorporativoService,
    private readonly keycloakService: KeycloakService,
  ){}

  carregarPerfis() {
    let promise = new Promise<void>((resolve, reject) => {
      this.perfilCorporativoService.consultarPerfisPorUsuario(this.keycloakService.getUsername())
        .toPromise()
        .then(
          res => {
           this.setPerfis(res);
            resolve();
          }
        ).catch((error) => {
          // TODO
        });
    });

    return promise;
  }

  isPerfilAcessoPleitoMCTI(): boolean {
    const perfis = this.getPerfis();
    return perfis.includes(perfis.find(perfil =>
      perfil.nome === PerfilEnum.AnalistaMctic ||
      perfil.nome === PerfilEnum.ApoioTecnico ||
      perfil.nome === PerfilEnum.ChefeDivisao ||
      perfil.nome === PerfilEnum.Coordenador ||
      perfil.nome === PerfilEnum.CoordenadorG ||
      perfil.nome === PerfilEnum.Diretor
    ));
  }

  isPerfilApoioTecnico(): boolean {
    const perfis = this.getPerfis();
    return perfis.includes(perfis.find(perfil =>
      perfil.nome === PerfilEnum.ApoioTecnico
    ));
  }

  setPerfis(perfis: PerfilCorporativoVO[]) {
    this.perfis.next(perfis);
  }

  getPerfis() {
    return this.perfis.value;
  }
}
